import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPillOff = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_10035_25390",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_10035_25390)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M14.1621 11.8702L13.2919 11L14.9586 9.33335C15.2364 9.05557 15.4516 8.72918 15.6044 8.35418C15.7572 7.97918 15.8336 7.59029 15.8336 7.18751C15.8336 6.35418 15.5384 5.64237 14.9482 5.0521C14.3579 4.46182 13.6461 4.16668 12.8128 4.16668C12.41 4.16668 12.0211 4.24307 11.6461 4.39585C11.2711 4.54862 10.9447 4.7639 10.6669 5.04168L9.00025 6.70835L8.13005 5.83814L9.7888 4.17147C10.1957 3.7698 10.6587 3.46029 11.1778 3.24293C11.6966 3.02543 12.2408 2.91668 12.8103 2.91668C14 2.91668 15.0096 3.3314 15.8392 4.16085C16.6688 4.99015 17.0836 5.99994 17.0836 7.19022C17.0836 7.75994 16.9748 8.30418 16.7573 8.82293C16.54 9.34168 16.2305 9.80453 15.8288 10.2115L14.1621 11.8702ZM7.18775 15.8333C7.59053 15.8333 7.97942 15.757 8.35442 15.6042C8.72942 15.4514 9.05581 15.2361 9.33359 14.9583L11.2263 13.0656L6.93463 8.77397L5.04192 10.6667C4.76414 10.9445 4.54886 11.2708 4.39609 11.6458C4.24331 12.0208 4.16692 12.4097 4.16692 12.8125C4.16692 13.6458 4.46206 14.3577 5.05234 14.9479C5.64261 15.5382 6.35442 15.8333 7.18775 15.8333ZM16.4682 18.3077L12.0965 13.9358L10.2117 15.8286C9.81005 16.2302 9.34866 16.5397 8.82755 16.7571C8.3063 16.9746 7.7597 17.0833 7.18775 17.0833C5.99831 17.0833 4.98914 16.6686 4.16025 15.8392C3.33136 15.0099 2.91692 14.0001 2.91692 12.8098C2.91692 12.2401 3.02567 11.6945 3.24317 11.1731C3.46053 10.6517 3.77005 10.1902 4.17171 9.78855L6.06442 7.90376L1.77588 3.61543L2.65421 2.7373L17.3463 17.4294L16.4682 18.3077Z",
			fill: "currentColor"
		})
	})]
});
export default SvgPillOff;
